"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LikeRequestDTOSchema = exports.LikeDTO = exports.LikeSchema = exports.LikeBaseSchema = void 0;
var zod_1 = require("zod");
var ObjectId_1 = require("./lib/ObjectId");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var User_1 = require("./User");
var Post_1 = require("./Post");
exports.LikeBaseSchema = zod_1.z.object({
    user: zod_1.z.instanceof(ObjectId_1.ObjectId),
    post: zod_1.z.instanceof(ObjectId_1.ObjectId),
    comment: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
});
exports.LikeSchema = exports.LikeBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
var LikeDTOSchema = exports.LikeSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.LikeDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            user: (0, ObjectId_1.isPopulated)(model.user) ? User_1.UserDTO.convertFromModel(model.user) : model.user.toString(),
            post: (0, ObjectId_1.isPopulated)(model.post) ? Post_1.PostDTO.convertFromModel(model.post) : model.post.toString(),
            comment: model.comment ? model.comment.toString() : undefined,
        };
        return dto;
    },
};
exports.LikeRequestDTOSchema = LikeDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { user: (0, ObjectId_1.ObjectIdString)('Invalid user id'), post: (0, ObjectId_1.ObjectIdString)('Invalid post id'), comment: (0, ObjectId_1.ObjectIdString)('Invalid comment id').optional() }));
//# sourceMappingURL=Like.js.map